import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { post } from 'jquery';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from 'src/app/shared/loader.service';
import { MessageService } from 'src/app/shared/message.service';
import { OrcamentoService } from 'src/app/shared/services/orcamento.service';
import { SessionService } from 'src/app/shared/services/session.service';
declare var $: any;

@Component({
  selector: 'app-fotos',
  templateUrl: './fotos.component.html',
  styleUrls: ['./fotos.component.css']
})

export class FotosComponent implements OnInit {
  index: number = 0
  veiculo: any
  base64: string
  @ViewChild('fotos', { static: false }) fotos: ElementRef;
  imagens: Array<foto> = new Array
  imagem: Object
  post: Array<any> = new Array
  tipo: string
  listaImgDelete: Array<any> = [];
  uuidUser: string;
  uuidEmpresa: string;
  permitirExclusaoTerceiro: boolean = false;
  readonly: boolean = false;

  get existeImage() {
    return this.imagens.length > 0 ? true : false
  }
  constructor(public bsModalRef: BsModalRef,
    private rest: OrcamentoService,
    private info: MessageService,
    private loader: LoaderService,
    private session: SessionService
  ) { }

  private readFile(file: any, tipo: string, indexImg: any): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (fileCarregado) => {
        let imgbase64 = fileCarregado.target.result
        this.imagem = {
          index: indexImg,
          tipo: tipo,
          imagem: imgbase64
        }
        this.post.push(this.imagem)

        resolve(reader.result as string);
      }
      reader.readAsDataURL(file);
    });
  }

  async postFotos(fotos: any) {
    fotos = fotos.files;
    this.index = 0;
    let array = Object.keys(fotos);
    if (array.length == 0) {
      this.info.showErro('Nenhuma foto foi selecionada');
      return;
    }
    this.loader.show();

    for (var key = 0, len = array.length; key < len; key++) {
      this.loader.setText("Preparando a " + (key + 1) + " foto, aguarde...")
      this.index++;
      let file = fotos[key];
      let tipo = file.type;
      tipo = tipo.replace(/image/g, '').replace('/', "");
      await this.readFile(file, tipo, this.index);
      //já carregou todos?
      if (key + 1 == array.length) {
        this.loader.setText("Salvando, aguarde...");
        let uuid = this.veiculo.dados.uuid;
        this.rest.saveImages(uuid, this.post, this.uuidUser, this.uuidEmpresa, this.permitirExclusaoTerceiro).subscribe((data) => {
          this.getImagens();
          this.post = [];
          this.index = 0;
          this.fotos.nativeElement.value = "";
        }, ((err) => {
        }))
      }
    };
  }

  getImagens() {
    let uuid = this.veiculo.dados.uuid
    this.rest.getImages(uuid).subscribe((data) => {
      if (data.data[0] != 'Dados não localizados!') {
        this.imagens = data.data as Array<foto>;
        this.permitirExclusaoTerceiro = this.imagens[0]?.permitir_exclusao_terceiro;
        if (this.heEmpresaDonaDoOrcamento()) {
          if (!this.permitirExclusaoTerceiro)
            $('#flexSwitchCheckDefault').removeAttr('checked');
        }
      }
      /* setTimeout(function () {
        $("a[rel=galeria]").fancybox();
      }, 500); */
    });
  }

  multDeleteImage() {
    let uuid = this.veiculo.dados.uuid
    if (this.listaImgDelete.length != 0) {
      this.rest.deleteMultImage(uuid, this.listaImgDelete).subscribe((data: any) => {
        if (data.status == 'success')
          this.info.showSuccess('Imagens apagadas com sucesso!')
        else
          this.info.showErro('Algumas imagens não foi apagada, entre em contato com o administrador')
        this.getImagens();
      })
    }
    else {
      this.info.showErro('Selecione ao menos 1 imagem para prosseguir')
    }
    this.listaImgDelete = []
    $('.select-img').prop('checked', false)
    this.imagens = []
  }

  alteraCheck(linkImg: string, checkbox: any = null) {
    if (this.listaImgDelete.indexOf(linkImg) == -1) {
      this.listaImgDelete.push(linkImg);
      $(`#${checkbox}`).prop('checked', true)
    }
    else {
      let index = this.listaImgDelete.indexOf(linkImg);
      this.listaImgDelete.splice(index, 1);
      $(`#${checkbox}`).prop('checked', false)
    }
  }

  deleteImage(image) {
    let uuid = this.veiculo.dados.uuid
    this.rest.deleteImage(uuid, image.arquivo).subscribe((data) => {
      this.getImagens();
    }, ((err) => { }))
  }

  editImage(image, fotos) {
    this.deleteImage(image)
    this.postFotos(fotos)

  }
  ngOnInit(): void {
    this.getImagens()
    this.uuidUser = this.session.getUUIDUsuario();
    this.uuidEmpresa = this.session.getUUIDEmpresa();
  }

  alternarPermissaoExclusaoDeFotos() {
    let novoValor: boolean = !this.permitirExclusaoTerceiro;
    let stringListaUUIDsArquivos: string = '';
    this.imagens.forEach((e: foto) => {
      stringListaUUIDsArquivos += `'${e.uuid}',`;
    });
    stringListaUUIDsArquivos = stringListaUUIDsArquivos.substring(0, stringListaUUIDsArquivos.length - 1);
    this.rest.atualizarPermissaoFotos(novoValor, stringListaUUIDsArquivos).subscribe((data: any) => {
      if (data.status == 'success') {
        this.permitirExclusaoTerceiro = novoValor;
      }
    });
  }

  heEmpresaDonaDoOrcamento(): boolean {
    return this.veiculo.dados.uuid_emp_orcamento == this.session.getUUIDEmpresa()
  }
}

export class foto {
  arquivo: string //Nome do Arquivo
  tipo: string //tipo do arquivo
  uuid: string //uuid do arquivo
  uuid_usuario_adicao: string //uuid do usuario que adicionou o arquivo
  uuid_empresa_adicao: string //uuid da empresa que adicionou o arquivo
  permitir_exclusao_terceiro: boolean //permitir_exclusao_terceiro
}